import React, { Component } from 'react';
import './FlickSlider.css';
import Slider from "react-slick";
import CSSAnimate from "../CSSAnimate/CSSAnimate";
import { Link } from "react-router-dom";
import { Container } from 'react-grid-system';
import HoverLink from '../HoverLink/HoverLink';
import { withProjectsContext } from "../../ProjectsContext";
import { WP_URL } from "../../config";




// The slider asset is one ACF file field, so its type is whatever was uploaded.
// Reading that off the extension keeps the markup honest even when the editor
// forgets a checkbox, which the old `is_video` flag could not.
const VIDEO_FILE = /\.(mp4|m4v|mov|webm|ogv)(\?|#|$)/i;
const isVideo = (url) => VIDEO_FILE.test(String(url || ""));

// The "interaction" select in WordPress stores its labels ("Pan Left"), so the
// class comes off the label rather than a value we control. Anything else —
// including the empty option, and prod, which has no such field yet — leaves the
// slide still.
const INTERACTIONS = ["pan-left", "pan-right", "zoom-in", "zoom-out"];
const interactionClass = (interaction) => {
    const name = String(interaction || "").trim().toLowerCase().replace(/\s+/g, "-");
    return INTERACTIONS.includes(name) ? `interaction interaction--${name}` : undefined;
};

export const PrevArrow = (props) => {
    const { onClick } = props;
    return (
        <div className={"arrows left"} onClick={onClick}></div>
    )
}

export const NextArrow = (props) => {
    const { onClick } = props;
    return (
        <div className="arrows right" onClick={onClick}></div>
    )
}

class FlickSlider extends Component {


constructor(props, context) {
    super(props, context);

    this.state = {
        activeSlide: 0,
        activeSlide2: 0,
        slides: [],
        isVisible: false
    }
}

componentDidMount = () => {
    fetch(`${WP_URL}/wp-json/acf/v3/custom-page/1069`)
        .then(response => response.json())
        .then(data => {
            const slides = data.acf.slider_assets.map(asset => ({
                image: asset.slider_asset,
                title: asset.slide_title,
                video: isVideo(asset.slider_asset),
                link: `/work/${asset.project_slug}`,
                poster: asset.video_poster,
                interaction: asset.interaction
            }));
            this.setState({ slides, isVisible: true });
        })
        .catch(error => {
            console.error('Error fetching slider data:', error);
        });
}

    renderSlides() {
        return this.state.slides.map((el, i) => {
            return(
                <div key={i}>
                    <Link to={this.state.slides[this.state.activeSlide].link}>
                        {el.video ?
                                <video muted loop playsInline={true} controls={false} poster={el.poster} onLoadedData={(e) => this.handleVideoReady(e.currentTarget)}>
                                    <source src={el.image} />
                                    Your browser does not support the video tag.
                                </video>
                            : 
                            <img src={el.image} alt={el.title} className={interactionClass(el.interaction)}/>
                        }
                    </Link>
                </div>
            )
        })
    }

    // When a video finishes loading, start it only if its slide is the one
    // currently shown. Covers the first slide on page load (react-slick fires
    // onInit before the DOM exists, so we can't rely on that for the first play).
    handleVideoReady = (video) => {
        const slide = video.closest(".slick-slide");
        if (slide && slide.classList.contains("slick-current") && video.paused) {
            video.currentTime = 0;
            video.play().catch(() => {});
        }
    };

    // Play only the given slide's video from the start; pause every other
    // slider video so they don't all run in the background at once.
    playSlideVideo = (index) => {
        const slider = document.querySelector(".container.slider");
        if (!slider) return;
        slider.querySelectorAll("video").forEach((v) => v.pause());
        const video = slider.querySelector(`.slick-slide[data-index="${index}"] video`);
        if (!video) return;
        video.currentTime = 0;
        const played = video.play();
        if (played) {
            played.catch(() => {
                // Not buffered yet (happens for the first video on load) —
                // play as soon as it has enough data.
                video.addEventListener("canplay", () => video.play().catch(() => {}), { once: true });
            });
        }
    };


    render() {
        const settings = {
            className: "",
            dots: false,
            fade: true,
            cssEase: "ease",
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 5000,
            pauseOnHover: false,
            speed: 1000,
            nextArrow: <NextArrow />,
            prevArrow: <PrevArrow />,
            beforeChange: (current, next) => {
                setTimeout(() => {this.setState( {activeSlide: next }) }, 10);
                this.playSlideVideo(next);
            },
            afterChange: (current) => this.setState({ activeSlide2: current })
        };

        return (
            <Container className="container slider" fluid={true} style={{padding: 0}}>

                {this.state.isVisible && [
                    // The delay is on top of however long the WP fetch above took, so
                    // it reads as dead black at the top of the page rather than as a
                    // beat in the entrance. Just enough to fade rather than pop.
                    <CSSAnimate key="i" delay="250">
                        <div className="slider-shell">
                            <Slider {...settings}>
                                {this.renderSlides()}
                            </Slider>
                            <div className="description">
                                <div className="">
                                    <h3 className="reg text-bold"><HoverLink grey="true">{this.state.slides[this.state.activeSlide].title}</HoverLink></h3>
                                </div>
                                <div className="text-right">
                                    <h3 className="reg text-bold">{this.state.activeSlide + 1} &mdash; {this.state.slides.length < 10 ? `0${this.state.slides.length}` : this.state.slides.length}</h3>
                                </div>
                            </div>
                        </div>
                    </CSSAnimate>
                ]}
            </Container>
        )
    }
}

export default withProjectsContext(FlickSlider);
